import { render, staticRenderFns } from "./ImsTask.vue?vue&type=template&id=e2ce7160&scoped=true"
import script from "./ImsTask.vue?vue&type=script&lang=js"
export * from "./ImsTask.vue?vue&type=script&lang=js"
import style0 from "./ImsTask.vue?vue&type=style&index=0&id=e2ce7160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce7160",
  null
  
)

export default component.exports